module.exports = __webpack_public_path__ + "img/spade-logo.11ad42a9.png";